import React from "react";
import BreadCrumb from "common/breadcrumb";
import CardTitle from "./card-title";
import HorizontalCard from "./horizontal-card";
import CardAnimation from "./card-animation";
import BorderCard from "./border-card";
import DashedBorderCard from "./dashed-border-card";
import FillCard from "./fill-card";
import ModernCard from "./modern-card";
import GroupCard from "./group-card";

const UiCards = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Cards' pageTitle='UI Elements' />

                <CardTitle />
                <HorizontalCard />
                <CardAnimation />
                <BorderCard />
                <DashedBorderCard />
                <FillCard />
                <ModernCard />
                <GroupCard />
            </div>
        </React.Fragment>
    );
}

export default UiCards;